/** Extract markdown tables from a string — returns an array of table line groups. */
export function extractMarkdownTables(markdown: string): string[][] {
    const tables: string[][] = [];
    const lines = markdown.split('\n');
    let currentTable: string[] = [];

    for (const line of lines) {
        const trimmed = line.trim();
        if (trimmed.startsWith('|') && trimmed.endsWith('|')) {
            // Skip separator rows (e.g. |---|---|)
            if (/^\|[\s\-:|]+\|$/.test(trimmed)) continue;
            currentTable.push(trimmed);
        } else if (currentTable.length > 0) {
            tables.push(currentTable);
            currentTable = [];
        }
    }
    if (currentTable.length > 0) tables.push(currentTable);

    return tables;
}

/** Convert a markdown table (array of pipe-delimited lines) to CSV. */
export function markdownTableToCsv(tableLines: string[]): string {
    return tableLines
        .map((line) =>
            line
                .split('|')
                .filter((cell) => cell.trim() !== '')
                .map((cell) => {
                    const value = cell.trim();
                    if (value.includes(',') || value.includes('"')) {
                        return `"${value.replace(/"/g, '""')}"`;
                    }
                    return value;
                })
                .join(','),
        )
        .join('\n');
}

/** Trigger a CSV file download in the browser. */
export function downloadCsv(csv: string, filename: string) {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
}

/** Check whether a string contains at least one markdown table. */
export function contentHasTable(content: string): boolean {
    return /^\|.+\|$/m.test(content);
}

/** Download all markdown tables from content as a single CSV. */
export function handleDownloadTables(content: string, filenamePrefix = 'table') {
    const tables = extractMarkdownTables(content);
    if (tables.length === 0) return;

    const csvParts = tables.map((t) => markdownTableToCsv(t));
    const csv = csvParts.join('\n\n');
    const timestamp = new Date().toISOString().slice(0, 10);
    downloadCsv(csv, `${filenamePrefix}-${timestamp}.csv`);
}
